import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Adminstration_User_Dropdown_Last-Access",
    transform: "translate(-830.000000, -261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown",
    transform: "translate(671.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sort-Z-A",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox-Option",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-arrow-down",
    transform: "translate(149.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\uD83C\uDFA8-Icon-Color",
    points: "6.66666667 11.3333334 5.33333333 11.3333334 5.33333333 3.33333332 1.66666665 7 0.719999978 6.05333333 6 0.773333312 11.28 6.05333333 10.3333334 7 6.66666667 3.33333332"
  }))))))));
});